import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { TestQueryService } from "../../test-query.service";
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  validateForm: FormGroup;
  password:any;
  username:any;
  nowIp:any;

  submit(): void {
    
    let dbdata = {
      headers: new HttpHeaders({'Content-Type' : 'application/json'})
    }
    let data = {
      userName:this.username,
      password:this.password
    }
    let api = this.nowIp+':8809/login/get/';
    this.http.post(api,data,dbdata).subscribe((res:any)=>{
      if(res==200){
        this.router.navigate(['home']);
      }else if(res==401){
        this.message.create("error", `账号或密码不正确！`);
      }
    })
  }
  goregister(): void {
    this.router.navigate(['register']);
  }

  constructor(
    private fb: FormBuilder,
    public router: Router,
    public http:HttpClient,
    public ml:TestQueryService,
    private message: NzMessageService
    ) {}

  ngOnInit(): void {

    
    const xhr = new XMLHttpRequest();
    const url = 'assets/server.json'
    xhr.open('GET',url,false)
    xhr.send()
    if (xhr.status == 200) {
      if(xhr.response!=null){
        this.nowIp = JSON.parse(xhr.response).serverAPI
      }
    }

    this.validateForm = this.fb.group({
      userName: [null, [Validators.required]],
      password: [null, [Validators.required]],
      remember: [true]
    });
  }
}
